import { PractitionerSearchResultApi } from './../../utils/interfaces/new/PractitionerSearchResultApi';
import { ActionEnum, DomainEnum, LogFonctionnelCallerService, LogFonctionnelService, LogObject, ResultEnum, TypeTargetEnum } from "../log-fonctionnel/log-fonctionnel.service";
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import moment from 'moment';
import { BehaviorSubject } from 'rxjs';
import { Filtres } from 'src/app/utils/interfaces/new/filtres.interface';
import { IdentifiantsTemporairesConnexion } from 'src/app/utils/interfaces/new/identifiantsTemporairesConnexion';
import { MessageReleveBio } from 'src/app/utils/interfaces/new/MessageReleveBio';
import { MessageReleveBioHTML } from 'src/app/utils/interfaces/new/MessageReleveBioHTML';
import { MSSClinicalDocumentInfo } from 'src/app/utils/interfaces/new/mss-clinical-document-info.interface';
import { EmailAuthent } from 'src/app/utils/interfaces/new/mss-email-authent.interface';
import { MSSFolderValidate } from 'src/app/utils/interfaces/new/mss-folder-validate.interface';
import { MSSFolder } from 'src/app/utils/interfaces/new/mss-folder.interface';
import { MSSMessageValidate } from 'src/app/utils/interfaces/new/mss-message-validate.interface';
import { MSSAttachment, MSSMessage, MSSMessageToSend } from 'src/app/utils/interfaces/new/mss-message.interface';
import { MessageReleve } from 'src/app/utils/interfaces/new/mss-messagereleve';
import { MSSFullTextSearchCriteria, MSSSearchCriteria } from 'src/app/utils/interfaces/new/mss-search-criteria.interface';
import { MSSSyncMessagesResponse } from 'src/app/utils/interfaces/new/mss-sync-messages-response.interface';
import { PractitionerSearchResult } from 'src/app/utils/interfaces/new/PractitionerSearchResult';
import { environment } from 'src/environments/environment';
import { FiltresService } from '../filtres/filtres.service';
import { Paginated } from 'src/app/utils/interfaces/new/paginated.interface';

export const PATIENT_MSS_ADDRESS_SUFFIX = '@patient.mssante.fr';

export interface PractitionerSearchParams {
  practitionerName?: string;
  firstName?: string;
  profession?: string;
  speciality?: string;
  structureOrAddress?: string;
  zip?: string;
  city?: string;
  rpps?: string;
  emailMSS?: string;
}

export interface PractitionerSearchParamsAPICRYPT {
  departement?:string;
  mail?: string;
  firstName?: string;
  practitionerName?: string;
  specialite?: string;
  postalCode?: string;
  ville?: string;
  rpps?: string;
}

export interface MessageReleveTmp {
  messageId: string;
  patientDateNaissance?: string;
  patientIns?: string;
  patientInsKey?: string;
  patientNomNaissance?: string;
  patientOid?: string;
  patientPrenomNaissance?: string;
  patientSexe?: string;
  patientCpNaissance?: string;
  isCrBio?: boolean;
  isHorsLimite?: boolean;
  isHorsLimiteCritique?: boolean;
}

export interface UpdateMessageReleve extends MessageReleveTmp {
  isInsOk: boolean;
  patientId?: string;
  patientValideId?: string;
  patientRecupereId?: string;
  patientProvisoireId?: string;
}

const MESSAGERIE_PATH = '/messagerie/';

const MSS_PATHS = {
  releverMessage: 'messages/relever',  // OK
  messagesReleves: 'messages/releves',  // OK
  markMessageAsRead: 'messages/releves/mark-as-read',
};

const httpOptions = {
  withCredentials: true,
  observe: 'response' as 'response',
  headers: new HttpHeaders(),
  params: undefined
};
export abstract class MssServiceAbstract {

  public authenticationErrorSubject: BehaviorSubject<boolean>
    = new BehaviorSubject<boolean>(true);

  protected _logCallSrv: LogFonctionnelCallerService;

  constructor(
    protected _http: HttpClient,
    protected _filtreSrv: FiltresService,
    protected _logSrv: LogFonctionnelService
  ) {}

  protected async _addLog(obj: LogObject): Promise<void> {
      if (!this._logCallSrv && this._logSrv) {
          this._logCallSrv = this._logSrv.getConfiguration(DomainEnum.Messagerie);
      }
      if (this._logCallSrv) {
          this._logCallSrv.addLog(obj);
      }
  }

  abstract listFolders(email: EmailAuthent, folderId?: number): Promise<Array<MSSFolder>>;

  abstract createFolder(email: EmailAuthent, folderName: string, folderParentId: number): Promise<MSSFolderValidate>;

  abstract trashFolder(email: EmailAuthent, folderId: number): Promise<void>;

  abstract renameFolder(email: EmailAuthent, folderId: number, newFolderName: string): Promise<void>;

  abstract searchMessages(email: EmailAuthent, searchCriteria: MSSSearchCriteria, getcompletmessage?: boolean): Promise<Array<MSSMessage>>;

  /**
   * getMessageById
   * Méthode utilisée exclusivement par le service ApiCrypt pour récupérer un message
   * (le service MSS N'IMPLÉMENTE PAS cette méthode)
   */
  abstract getMessageById(email: EmailAuthent, messageId: string): Promise<MSSMessage>;

  abstract moveMessages(email: EmailAuthent, messageIds: Array<number>, destinationFolderId: number): Promise<void>;

  /*
  * L'objectif de cette méthode est de synchroniser les messages de la messagerie
  * Le token passé en paramètre permet au service de faire le différentiel des messages supprimés et modifiés (créés ou modifiés)
  * depuis le dernier appel avec ce token.
  * Pour le premier appel nous n'aurons pas de token et le service ne renverra qu'un token (et non les données de synchronisation).
  * Pour cette raison, il faudra appeler cette méthode (sans token donc) juste après l'appel à la méthode 'listFolders'.
  * De cette manière le service aura un point de départ pour renvoyer les données de synchronisation.
  *
  * Dans la pratique, l'appel à 'listFolders' est immédiatement suivi d'un appel à 'syncMessages' ce qui permet la récupération d'un token.
  * Ce token doit être conservé par le service dans une map le liant à l'email
  * de manière à éviter tout problème avec les changements de compte (de messagerie ou Hypermed)
  */
  abstract syncMessages(email: EmailAuthent, folderId?: number, syncToken?: string): Promise<MSSSyncMessagesResponse>;

  abstract downloadAttachment(email: EmailAuthent, messageId: number, attachment: MSSAttachment): Promise<{file: File, base64: string}>;

  abstract removeAttachment(email: EmailAuthent, messageId: number, attachment: MSSAttachment): Promise<void>;

  abstract deleteMessage(email: EmailAuthent, messageId: number | Array<number>): Promise<void>;

  abstract draftMessage(email: EmailAuthent, messages: MSSMessageToSend): Promise<MSSMessageValidate | undefined>;

  abstract sendMessage(email: EmailAuthent,
                       messages: MSSMessageToSend,
                       clinicalDocumentInfo?: MSSClinicalDocumentInfo): Promise<MSSMessageValidate | undefined>;

  abstract markMessageAsRead(email: EmailAuthent, messageId: number | Array<number>, technicalId?: string): Promise<void>;

  abstract fullTextSearchMessages(email: EmailAuthent, searchCriteria: MSSFullTextSearchCriteria): Promise<Array<MSSMessage>>;

  abstract findMSSRecipient(params: PractitionerSearchParams, limit: number,
                            offset: number, doForceSearch: boolean): Promise<PractitionerSearchResult>;

  abstract findMSSRecipientApi(params: PractitionerSearchParamsAPICRYPT, limit: number,
                            offset: number, doForceSearch: boolean): Promise<PractitionerSearchResultApi>;

  abstract connectToMSSByIDNAT(mail: string, password: string, typeOTP?: string): Promise<any>;

  abstract validateOTP(otp: string, identifiants: IdentifiantsTemporairesConnexion): Promise<void>;

  abstract storeToken(token: string, idNat: string): void;

  abstract clearToken(idNat: string): void;

  abstract listAccounts(idNat: string): Promise<string[]>;

  abstract canCreateFolders(): boolean;

  abstract canRenameFolders(): boolean;

  abstract canRemoveFolders(): boolean;

  abstract canListFolders(): boolean;

  abstract canMoveMessages(): boolean;

  abstract canSyncMessages(): boolean;

  abstract canRemoveAttachment(): boolean;

  abstract canDraftMessage(): boolean;

  abstract canMarkMessageAsRead(): boolean;

  abstract canGetMessage(): boolean;

  abstract isTokenNeeded(): boolean;

  abstract isOTPNeeded(): boolean;

  abstract isSearchMessageHandlePagination(): boolean;

  abstract mustDraftToAddAttachment(): boolean;

  abstract providerLibellePrefix(): string;

  abstract isSessionValid(email: EmailAuthent): Promise<boolean>;

  sauvegarderCourrierReleve(message: MSSMessage): Promise<MessageReleveTmp> {
    return new Promise<MessageReleveTmp>(async (resolve, reject) => {
      try {
        // console.log('releve', message);
        message.date = moment.utc(message.date).format('DD/MM/YYYY HH:mm:ss') as any;
        const rtd = await this._http.post<MessageReleveTmp>(
          `${environment.basePath + MESSAGERIE_PATH}${MSS_PATHS.releverMessage}`,
          message,
          httpOptions
        ).toPromise();

        resolve(rtd.body);
      } catch (e) {
        reject(e?.error);
      }
    });
  }

  async updateCourrierReleve(infosMessage: UpdateMessageReleve): Promise<void> {
    await this._http.put<MessageReleveTmp>(
      `${environment.basePath + MESSAGERIE_PATH}${MSS_PATHS.releverMessage}`,
      infosMessage,
      httpOptions
    ).toPromise();

    return;
  }

  getCourrierReleve(filtre: Filtres = {
    currentPage: 0,
    perpage: 0,
  }): Promise<Paginated<MessageReleve>> {
    return new Promise<Paginated<MessageReleve>>(async (resolve, reject) => {
      try {
        httpOptions.headers = this._filtreSrv.setHeaders(filtre);
        const response = await this._http.get<MessageReleve[]>(
          `${environment.basePath + MESSAGERIE_PATH}${MSS_PATHS.messagesReleves}`,
          httpOptions
        ).toPromise();
        resolve({
          page: Number(response.headers.get('x-page')),
          perpage: Number(response.headers.get('x-per-page')),
          total: Number(response.headers.get('x-total')),
          objects: response.body
        });
      } catch (e) {
        reject(e?.error);
      }
    });
  }

  isThereCourriersToProcess(): Promise<boolean> {
    return new Promise<boolean>(async (resolve, reject) => {
      try {
        const response = await this._http.get<boolean | undefined>(
          `${environment.basePath + MESSAGERIE_PATH}${MSS_PATHS.messagesReleves}/unprocessed/with-docs`,
          httpOptions
        ).toPromise();
        resolve(!!response.body);
      } catch (e) {
        reject(e?.error);
      }
    });
  }

  public async getMessageReleveById(id: string): Promise<MessageReleve> {
    return new Promise<MessageReleve>(async (resolve, reject) => {
      try {
        const response = await this._http.get<MessageReleve>(
          `${environment.basePath + MESSAGERIE_PATH}${MSS_PATHS.messagesReleves}/${id}`,
          httpOptions
        ).toPromise();
        resolve(response.body);
      } catch (e) {
        reject(e?.error);
      }
    });
  }

  /**
   * Permet de marquer comme lu un MessageReleve provenant de la base HMO
   *
   * @param messageId ID HMO du message à marquer comme lu
   * @returns
   */
  public async markMessageAsReadHmo(messageId?: string): Promise<void> {
    return new Promise<void>(async (resolve, reject) => {
      try {
        const params: HttpParams = new HttpParams().set('messageId', messageId);
        const options = {...httpOptions};
        options.params = params;
        await this._http.put<MessageReleve>(
          `${environment.basePath + MESSAGERIE_PATH}${MSS_PATHS.markMessageAsRead}`,
          null,
          options
        ).toPromise();
        resolve();
      } catch (e) {
        reject(e?.error);
      }
    });
  }

  deleteMessageReleve(id: string): Promise<boolean> {
    return new Promise<boolean>(async (resolve, reject) => {
      try {
        await this._http.delete<void>(
          `${environment.basePath + MESSAGERIE_PATH}${MSS_PATHS.messagesReleves}/${id}`,
          httpOptions
        ).toPromise();
        this._addLog({ action: ActionEnum.Delete, result: ResultEnum.Success, typeTarget: TypeTargetEnum.NONE, subDomain: 'Suppression message MSS archivé', details: `DELETE ${MSS_PATHS.messagesReleves}/${id}` });
        resolve(true);
      } catch (e) {
        this._addLog({ action: ActionEnum.Delete, result: ResultEnum.Error, typeTarget: TypeTargetEnum.NONE, subDomain: 'Suppression message MSS archivé', details: `DELETE ${MSS_PATHS.messagesReleves}/${id} - Erreur: ${e?.error?.message || 'Erreur inconnue'}` });
        reject(e?.error);
      }
    });
  }

  traiterMessageReleve(messageId: string, patientId: string, consultation: boolean, typeConsult:string, subjectConsult:string): Promise<boolean> {
    return new Promise<boolean>(async (resolve, reject) => {
      try {
        await this._http.post<void>(
          `${environment.basePath + MESSAGERIE_PATH}${MSS_PATHS.messagesReleves}`,
          {
            idMessage: messageId,
            consulation: consultation,
            idPatient: patientId,
            typeConsult:typeConsult,
            subjectConsult:subjectConsult,
          },
          httpOptions
        ).toPromise();
        this._addLog({ action: ActionEnum.Update, result: ResultEnum.Success, typeTarget: TypeTargetEnum.Patient, idTarget: patientId, subDomain: 'Intégration message MSS dans dossier patient', details: `POST ${MSS_PATHS.messagesReleves} (Message: ${messageId})` });
        resolve(true);
      } catch (e) {
        this._addLog({ action: ActionEnum.Update, result: ResultEnum.Error, typeTarget: TypeTargetEnum.Patient, idTarget: patientId, subDomain: 'Intégration message MSS dans dossier patient', details: `POST ${MSS_PATHS.messagesReleves} - Erreur: ${e?.error?.message || 'Erreur inconnue'}` });
        reject(e?.error);
      }
    });
  }

  getBioMessageReleve(messageId: string): Promise<MessageReleveBio> {
    return new Promise<MessageReleveBio>(async (resolve, reject) => {
      try {
        const response = await this._http.get<MessageReleveBio>(
          `${environment.basePath + MESSAGERIE_PATH}${MSS_PATHS.messagesReleves}/bio/${messageId}`,
          httpOptions
        ).toPromise();
        resolve(response.body);
      } catch (e) {
        reject(e?.error);
      }
    });
  }

  getBioMessageReleveHTML(messageId: string): Promise<MessageReleveBioHTML> {
    return new Promise<MessageReleveBioHTML>(async (resolve, reject) => {
      try {
        const response = await this._http.get<MessageReleveBioHTML>(
          `${environment.basePath + MESSAGERIE_PATH}${MSS_PATHS.messagesReleves}/bio/${messageId}/html`,
          httpOptions
        ).toPromise();
        resolve(response.body);
      } catch (e) {
        reject(e?.error);
      }
    });
  }
}
